/* eslint-disable max-len */

import React from 'react';
import type { SVGProps } from 'react';

export interface PositionTopProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

export const PositionTop: React.FC<PositionTopProps> = ({ color = 'none', ...props }) => {
  return (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2498 6.00195C20.2498 6.41617 19.914 6.75195 19.4998 6.75195H4.5C4.08579 6.75195 3.75 6.41617 3.75 6.00195C3.75 5.58774 4.08579 5.25195 4.5 5.25195H19.4998C19.914 5.25195 20.2498 5.58774 20.2498 6.00195Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4697 7.71796C11.7626 7.42507 12.2374 7.42507 12.5303 7.71796L16.2504 11.4379C16.5433 11.7308 16.5433 12.2057 16.2504 12.4986C15.9575 12.7915 15.4826 12.7915 15.1897 12.4986L12 9.30895L8.81036 12.4986C8.51747 12.7915 8.04259 12.7915 7.7497 12.4986C7.45681 12.2057 7.45681 11.7308 7.7497 11.4379L11.4697 7.71796Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 8.35815C12.4142 8.35815 12.75 8.69394 12.75 9.10815V18.7483C12.75 19.1625 12.4142 19.4983 12 19.4983C11.5858 19.4983 11.25 19.1625 11.25 18.7483L11.25 9.10815C11.25 8.69394 11.5858 8.35815 12 8.35815Z"
        fill={color}
      />
    </svg>
  );
};
